const durations = {
  short: '125ms',
  regular: '300ms',
  long: '450ms',
  fade: '2000ms',
  use: (milliseconds: number) => `${milliseconds}ms`,
};

export default durations;
